import { coreTagsGetAsyncSlice } from './get';
import { CoreTagsName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { RemoveSonarTagRequest } from '@types';

export const coreTagsRemoveSyncSlice = createRemoveSyncSlice({
	name: CoreTagsName,
	state: coreTagsGetAsyncSlice.asyncState,
	transform: (action: RemoveSonarTagRequest, state = []) => state.filter((tag) => tag.id !== action.id)
});
